/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { useEffect, useState } from "react";
import { API } from "../../../globals/globals";
import { useExportConditionsMutation, useGetConditionsQuery } from "../../../store/api/devices/deviceApiSlice";
import { useSelector } from "react-redux";
import { conditionsColumns } from "../../../components/Shared/Table/Columns";
import { searchKeywordByScopeSelector, searchKeywordSelector } from "../../../store/search/selector";
import { setDeviceCount, setOpenToast } from "../../../store/helpers/helperReducers";
import { useStoreDispatch } from "../../../store/hooks";
import { paginationModelSelector } from "../../../store/helpers/helperSelectors";
import { errorMessage, exportInCSV } from "../../../utils/helpers";
import { initialState } from "../../../store/helpers/helperInitialState";
import { useLocation } from "react-router-dom";
import { urlParameterConditionSelector } from "../../../store/filters/condition/ConditionFilterSelector";

export const useConditionDisplay = () => {
  const dispatch = useStoreDispatch();
  const location = useLocation();

  const locationPath = location?.pathname.split("/");

  const filters = useSelector(urlParameterConditionSelector);

  const keyword = useSelector(searchKeywordByScopeSelector("conditions"));
  const { conditionDisplay = initialState.pagination } = useSelector(paginationModelSelector);
  const [exportConditions, exportStatus] = useExportConditionsMutation();
  const [sortOrder, setSortOrderToCondition] = useState("retention,desc");

  filters.set("sort", sortOrder);
  filters.set("page", conditionDisplay.page.toString());
  filters.set("size", conditionDisplay.pageSize.toString());
  filters.set("search", keyword);

  const args:any = { filters: filters.toString() };
  // let args:any;
  // if (locationPath.includes("device")) {
  //   args = { filters: filters.toString(), deviceKey: locationPath[2] };
  // } else {
  //   args = { filters: filters.toString() };
  // }
  const { data, isLoading, refetch } = useGetConditionsQuery(args, {
    pollingInterval: API.ENDPOINTS.CONDITIONS.pollingInterval || API.POLLING_INTERVAL,
  });

  useEffect(() => {
    refetch();
  }, [filters.toString(), refetch]);

  useEffect(() => {
    dispatch(
      setDeviceCount({
        disconnectedDeviceCount: Number(localStorage.getItem("disconnected")),
        allDeviceCount: Number(localStorage.getItem("allDevice")),
        inMaintenanceModeCount: Number(localStorage.getItem("inMaintenanceMode")),
        ungroupedCount: Number(localStorage.getItem("ungrouped")),
        kpiSyncErrorCount: Number(localStorage.getItem("kpiErorrCount")),
        offLineDeviceCount: Number(localStorage.getItem("offLineDeviceCount")),
        configMismatchCount: Number(localStorage.getItem("configMismatchCount")),
      })
    );
  }, [dispatch]);

  const exportHandler = async () => {
    try {
      const response: any = await exportConditions(args);
      if (response?.error) throw response?.error;
      exportInCSV(response, "Conditions");
    } catch (error: any) {
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
    }
  };

  return {
    data,
    isLoading,
    conditionsColumns,
    exportHandler,
    exportStatus,
    setSortOrderToCondition,
  };
};
